import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export default function Loading() {
    return (
        <Box display="flex" flexDirection="column" alignItems="center" width="100%" gap={1} pt={1}>
            {[...Array(5)].map((row, index) => (
                <Skeleton
                    key={index}
                    height={70}
                    animation="wave"
                    variant="rounded"
                    sx={{ width: "100%" }}
                />
            ))}
        </Box>
    );
};